export class BaseModelClient {
    _apiHost;
    /**
     * @constructor
     * @private
     * @param [apiHost] Http host of the API.
     */
    constructor(apiHost) {
        this._apiHost = apiHost || null;
    }
    /**
     * Returns http host of the API.
     * @returns API host or `null`.
     */
    get apiHost() {
        return this._apiHost;
    }
    get credentials() {
        return 'same-origin';
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isPreloaded(url) {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPreloadedModel(url) {
        return Promise.reject(new Error('Model is not preloaded'));
    }
    getURL(modelPath) {
        // Either the API host has been provided or we make an absolute request relative to the current host
        const apihostPrefix = this._apiHost || location.origin;
        const url = `${apihostPrefix}${modelPath}`;
        return new URL(url);
    }
    /**
     * Fetches a model using given resource path.
     * @param modelPath Absolute path to the model.
     * @return Promise to page model object.
     */
    fetch(modelPath) {
        if (!modelPath) {
            const err = `Fetching model rejected for path: ${modelPath}`;
            return Promise.reject(new Error(err));
        }
        const url = this.getURL(modelPath);
        if (this.isPreloaded(url)) {
            return this.getPreloadedModel(url);
        }
        // Assure that the default credentials value ('same-origin') is set for browsers which do not set it
        // or which are setting the old default value ('omit')
        return fetch(url, {
            credentials: this.credentials,
        })
            .then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else if (response.status === 404 || response.status === 403 || response.status === 500) {
                return response.json();
            }
            throw {
                response,
            };
        })
            .catch((error) => {
            return this.onError(error);
        });
    }
    onError(error) {
        return Promise.reject(error);
    }
    /**
     * Destroys the internal references to avoid memory leaks.
     * @private
     */
    destroy() {
        this._apiHost = null;
    }
}
